/* Keep the selected variant, price, availability and quantity in the native Shopify form. */
if (!customElements.get('kalzen-bundle-buy-box')) {
  customElements.define('kalzen-bundle-buy-box', class extends HTMLElement {
    connectedCallback() {
      if (this.bundleReady) return;
      this.bundleReady = true;
      this.variantSelect = this.querySelector('[data-bundle-variant]');
      this.variantInput = this.querySelector('[data-bundle-id]');
      this.variants = JSON.parse(this.querySelector('[data-bundle-variants]')?.textContent || '[]');
      this.quantity = this.querySelector('[data-quantity-input]');
      this.minus = this.querySelector('[data-quantity-minus]');
      this.plus = this.querySelector('[data-quantity-plus]');
      this.add = this.querySelector('[data-bundle-add]');
      this.addLabel = this.querySelector('[data-bundle-add-label]');
      this.price = this.querySelector('[data-bundle-price]');
      this.compare = this.querySelector('[data-bundle-compare]');
      this.variantSelect?.addEventListener('change', () => {
        this.selectVariant();
        const url = new URL(window.location.href);
        url.searchParams.set('variant', this.variantSelect.value);
        window.history.replaceState({}, '', url);
      });
      this.minus.addEventListener('click', () => { this.normalizeQuantity(); this.quantity.stepDown(); this.normalizeQuantity(); });
      this.plus.addEventListener('click', () => { this.normalizeQuantity(); this.quantity.stepUp(); this.normalizeQuantity(); });
      this.quantity.addEventListener('change', () => this.normalizeQuantity());
      this.querySelector('form').addEventListener('submit', () => this.normalizeQuantity(), true);
      this.selectVariant();
    }
    selectVariant() {
      const id = this.variantSelect?.value || this.variantInput?.value;
      const variant = this.variants.find(item => String(item.id) === String(id));
      if (!variant) return;
      this.add.disabled = !variant.available;
      this.addLabel.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      this.price.textContent = variant.price;
      this.compare.textContent = variant.compare_price;
      this.compare.hidden = !variant.on_sale;
      const rule = variant.quantity_rule || {};
      this.quantity.min = rule.min || 1;
      this.quantity.step = rule.increment || 1;
      if (rule.max != null) this.quantity.max = rule.max;
      else this.quantity.removeAttribute('max');
      this.normalizeQuantity();
    }
    normalizeQuantity() {
      const min = Number(this.quantity.min) || 1;
      const step = Number(this.quantity.step) || 1;
      const max = this.quantity.max ? Number(this.quantity.max) : Infinity;
      const last = Number.isFinite(max) ? min + Math.floor((max - min) / step) * step : Infinity;
      const value = Number(this.quantity.value) || min;
      this.quantity.value = Math.min(last, min + Math.max(0, Math.round((value - min) / step)) * step);
      this.minus.disabled = Number(this.quantity.value) <= min;
      this.plus.disabled = Number(this.quantity.value) >= last;
    }
  });
}
